import React from 'react';
import { Link } from 'react-router-dom';
import flexFanLogo from '../../assets/img/login-imgs/flexfan-logo.png';
import loginScreenImage from '../../assets/img/login-imgs/loginscreen-img.png';
import './Login.css';

const Login = () => {
    return (
        <div className="row g-0">
            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center min-vh-100 mb-5 mb-lg-0">
                <div className="row w-100 d-flex justify-content-center align-items-center">
                    <div className="col-8">
                        <div className="d-flex align-items-center justify-content-center mb-5">
                            <img src={flexFanLogo} alt="logo image" />
                        </div>
                        <form>
                            <div className="row mb-4">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="text" placeholder="Email or Username" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="password" placeholder="Password" />
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col"><a className="login_link" href="#">Forgot password</a></div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">
                                    <div className="custom-button rounded-pill">
                                        <button className="inner-button rounded-pill" type="button" >
                                            Login
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <span className="login_txt">New here?</span>
                                    <Link className="login_link" to="/register"> Register</Link>
                                    
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        <div className="col-12 col-lg-6 p-0 vh-100">
            <img className="img-fluid vh-100 w-100" src={loginScreenImage} alt="logo screen Image" />
        </div>
    </div>
    );
};

export default Login;